import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PayScalesService } from '../pay-scales.service';
import { IPayScale } from '../pay-scales.types';

/**
 * PayScalesOverviewComponent
 */
@Component({
	selector: 'app-pilotpay-pay-scales-overview',
	templateUrl: './pay-scales-overview.component.html'
})

/**
 * PayScalesOverviewComponent
 */
export class PayScalesOverviewComponent implements OnInit {
	constructor(private router: Router, private payScalesService: PayScalesService) {}

	public isLoading: boolean = false;
	public payScales: IPayScale[] = [];
	public searchText: any;

	ngOnInit(): void {
		this.getPayScales();
	}

	public navigate = (payScaleId: number): void => {
		this.router.navigate(['/pilotpay/pay-scales', payScaleId]);
	};

	public navigateSetting = (): void => {
		this.router.navigate(['/pilotpay/pay-scales/settings']);
	};

	/**
	 * getPayScales
	 */
	private getPayScales(): void {
		this.isLoading = true;
		this.payScalesService.getPayScales(true).subscribe(
			(DATA: IPayScale[]) => {
				if (DATA) {
					this.payScales = [...[], ...DATA];
					this.isLoading = false;
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
				this.isLoading = false;
			}
		);
	}
}
